import { ModalRef, PathwayData } from 'constants/WorkingModePathwaysConstants'

import { PreworkSection } from './PreworkSection'
import { renderSegments } from './renderSegments'
import { SprintSection } from './SprintSection'

interface PathwayContentProps {
  data: PathwayData
  onOpenModal: (ref: ModalRef) => void
}

export const PathwayContent = ({ data, onOpenModal }: PathwayContentProps) => (
  <div className="flex flex-col gap-6 items-center w-full">
    <div className="flex flex-col gap-4 items-center text-center w-full">
      <p className="title-l w-full">{data.name}</p>
      <p className="body-s">{renderSegments(data.segments)}</p>
    </div>
    <div className="flex flex-col gap-1 items-start w-full">
      <div className="pathway-gradient-panel pathway-gradient-panel--top">
        <PreworkSection data={data.prework} onOpenModal={onOpenModal} />
      </div>
      <div className="pathway-gradient-panel pathway-gradient-panel--bottom">
        <SprintSection data={data.sprint} onOpenModal={onOpenModal} />
      </div>
    </div>
  </div>
)
